import React, {Component} from 'react';
import {connect} from 'react-redux'

import bindAll from 'lodash.bindall';
import AlertComponent from '../components/alert/alert.jsx';

class AlertContainer extends React.Component {

    constructor(props) {
        super(props)
        bindAll(this, [

        ]);
        this.state = {
            inputVlue: "",

        }
    }



    render() {

        return (
            <AlertComponent
                msg={this.props.msg}
                status={this.props.status}
            />
        )
    }


}

AlertContainer.propTypes = {
    // count: PropTypes.Number.isRequired,
}


const mapStateToProps = state => {
    return {
        msg: state.alert.msg,
        status: state.alert.status,
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AlertContainer);
